module.exports = __webpack_public_path__ + "img/hok.b87050cb.jpg";